import { render } from "./page-login.vue?vue&type=template&id=572f95eb"
import script from "./page-login.vue?vue&type=script&lang=js"
export * from "./page-login.vue?vue&type=script&lang=js"
script.render = render

export default script